import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { triggersClient } from '../../../../utils/apollo/api'
import { useTableActions } from '../../../../components/tables/MultiSelectTableContext'

const MUTATION = gql`
  mutation RetryTriggerCall($id: Int) {
    retryTriggerCall(id: $id) {
      id
    }
  }
`

export const useRetryTriggerCall = () => {
  const { t } = useTranslation(['triggerCalls', 'common'])
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['TriggerCalls', 'TriggerCallsCount'],
    client: triggersClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { clearSelection } = useTableActions()

  const handleRequest = id => {
    if (!modal.confirm({ title: t('triggerCalls:confirmRetry') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        if (clearSelection) clearSelection()
      } else {
        notify.error({ title: t('common:errorMessage') })
      }
    })
  }

  return [handleRequest, state]
}
